// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yg2M","toggle":"styles_toggle__3IHNv","preview":"styles_preview__27pVB"};